<div class="w-full mt-auto p-4 md:p-6 text-neutral-600">
  <div class="flex flex-wrap justify-center items-center gap-1">
    <a
      class="app-footer-link"
      [routerLink]="['/', location.uuid, 'legal', 'policies']"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'shared.footer.link-policies' | translate }}
    </a>
    |
    <a
      class="app-footer-link"
      [routerLink]="['/', location.uuid, 'legal', 'terms']"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'shared.footer.link-terms' | translate }}
    </a>
    |
    <a
      class="app-footer-link"
      [routerLink]="['/', location.uuid, 'legal', 'privacy']"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'shared.footer.link-privacy' | translate }}
    </a>
  </div>
  <br />
  <p>
    {{ copyrightKey | translate: copyrightParams }}
  </p>

  <span [innerHTML]="translatedPoweredByText$ | async"></span>
</div>
